import useModificationAlert from './use-modification-alert';
import { SweetAlertResult } from 'sweetalert2';
import { SweetAlertHookApi, OpenAlertOptions } from 'types';

const useDeleteAlert = (): SweetAlertHookApi => {
  const Alert = useModificationAlert();

  const open = (
    { onCancel, onSubmit, ...options }: OpenAlertOptions = {} as OpenAlertOptions
  ): Promise<SweetAlertResult | void> => {
    return Alert.open({
      ...options
    }).then(async (result: SweetAlertResult | void) => {
      if (result && result.value && onSubmit) {
        onSubmit(result);
      } else if (onCancel) {
        onCancel();
      }
    });
  };

  return {
    open
  };
};

export default useDeleteAlert;
